import axios from './CommonHttpRequest';
let baseUrl = `${process.env.REACT_APP_RECUITER_API}`;


export const AdminAddNewRecruiter = async(body:any)=>
{
   const addURL =  `${baseUrl}api/RecruiterSignUpByRole/AddRecruiter`;
   return await axios.post(addURL, body);
}